module.exports = __webpack_public_path__ + "img/stickers_0001_100.063326fe.png";